module.exports = __webpack_public_path__ + "images/emoji/tangerine.72d138423faf444e893a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/tangerine.png
// module id = Uxml
// module chunks = 1